import { render, staticRenderFns } from "./Mergebokgi.vue?vue&type=template&id=36b1dbb7&"
import script from "./Mergebokgi.vue?vue&type=script&lang=js&"
export * from "./Mergebokgi.vue?vue&type=script&lang=js&"
import style0 from "./Mergebokgi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports